/**
 * @generated SignedSource<<0fb0d49e873509d2824daac87c72b04c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ZnglyContext_User_Query$variables = Record<PropertyKey, never>;
export type ZnglyContext_User_Query$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"User_Fragment">;
  } | null | undefined;
};
export type ZnglyContext_User_Query = {
  response: ZnglyContext_User_Query$data;
  variables: ZnglyContext_User_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZnglyContext_User_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "User_Fragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ZnglyContext_User_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nicename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "size",
                "value": 10
              }
            ],
            "concreteType": "Avatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": "avatar(size:10)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User_Meta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobRole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "profileImage",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaItemUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mimeType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaDetails",
                    "kind": "LinkedField",
                    "name": "mediaDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceUrl",
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User_Meta_profileSocialLinks",
                "kind": "LinkedField",
                "name": "profileSocialLinks",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User_Meta_profileArticleLinks",
                "kind": "LinkedField",
                "name": "profileArticleLinks",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconName",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nickname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capabilities",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "09868e6d84d8f9be70d41dd971e81eff",
    "id": null,
    "metadata": {},
    "name": "ZnglyContext_User_Query",
    "operationKind": "query",
    "text": "query ZnglyContext_User_Query {\n  viewer {\n    ...User_Fragment\n    id\n  }\n}\n\nfragment User_Fragment on User {\n  id\n  slug\n  role\n  username\n  name\n  nicename\n  avatar(size: 10) {\n    url\n  }\n  meta {\n    jobRole\n    profileImage {\n      id\n      mediaItemUrl\n      mimeType\n      mediaDetails {\n        sizes {\n          sourceUrl\n          name\n        }\n      }\n      description\n    }\n    profileSocialLinks {\n      name\n      url\n    }\n    profileArticleLinks {\n      name\n      iconName\n      url\n    }\n  }\n  nickname\n  firstName\n  lastName\n  description\n  email\n  capabilities\n}\n"
  }
};
})();

(node as any).hash = "0cec89560bd54a0fe1571dabd1fdec88";

export default node;
